import { h, Component } from "preact";
import { css } from "emotion";
import Button from "../../components/Button";
import { Link } from "preact-router/match";
import { hexToRgba } from "../../utils/Format";

const styles = {
  rightCol: css`
    width: 100%;
    overflow: hidden;
    position: relative;
    margin-left: 16px;
    @media (max-width: 600px) {
      max-width: 292px;
      height: 118px;
    }
  `,
  buttonContainer: css`
    margin-left: auto;
    margin-right: auto;
    right: 0;
    bottom: 0;
    position: absolute;
    @media (max-width: 600px) {
      display: none;
    }
  `,
  link: css`
    text-decoration: none !important;
    color: inherit !important;
  `
};
/**
 * Display tiles view of featured events
 *
 * @param {*} props
 * @returns
 */
const EventImageListView = props => {
  const { event, theme = {}, showPrice, eventListingLayout } = props;

  let bannerImage =
    event.featureImage && event.featureImage.url
      ? event.featureImage.url
      : null;
  bannerImage =
    event.socialImage && event.socialImage.url
      ? event.socialImage.url
      : bannerImage;
  bannerImage =
    event.bannerImage && event.bannerImage.url
      ? event.bannerImage.url
      : bannerImage;
  const eventLink = `/${event.slug}`;
  const eventTitle =
    eventListingLayout === "eventTitle"
      ? event.name
      : event.location.titleLocation;
  const eventInfo =
    eventListingLayout === "eventTitle"
      ? event.location.titleLocation
      : event.name;
  const width = typeof screen !== "undefined" ? screen.width : null;
  const mobileEventLink = width < 600 ? eventLink : null;
  const customStyles = {
    wrapper: css`
      width: 100%;
      max-width: 720px;
      max-height: 132px;
      height: 100%;
      display: flex;
      margin-bottom: 12px;
      border-radius: 4px;
      overflow: hidden;
      padding: 16px;
      background: ${hexToRgba(
        theme.eventCardBackgroundColor,
        theme.cardAndBarOpacity
      )};
      box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);
      @media (max-width: 600px) {
        margin-top: 12px;
        flex-direction: column;
        max-width: auto;
        width: 100%;
        max-height: 100%;
        padding: 0px;
      }
    `,
    image: css`
      width: 200px;
      min-width: 200px;
      height: 100px;
      border-radius: 4px;
      background: url(${bannerImage}) center center / cover no-repeat
        rgb(238, 238, 238);
      @media (max-width: 600px) {
        width: 100%;
        max-width: 100%;
        height: 100%;
        border-radius: 0px;
        padding-top: 50%;
      }
    `,
    contents: css`
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: ${theme.eventCardBackgroundColor === "#ffffff"
        ? "#323232"
        : "#ffffff"};
      max-width: 350px;
      width: 100%;
      @media (max-width: 600px) {
        font-size: 14px;
      }
    `,
    title: css`
      font-size: 18px;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 4px;
      white-space: nowrap;
      color: ${theme.eventCardBackgroundColor === "#ffffff"
        ? "#323232"
        : "#ffffff"};
      @media (max-width: 600px) {
        font-size: 16px;
        margin-top: 16px;
      }
    `
  };

  return (
    <Link href={mobileEventLink} className={styles.link}>
      <div className={customStyles.wrapper}>
        <div className={customStyles.image} />
        <div className={styles.rightCol}>
          <div className={customStyles.title}>{eventTitle}</div>
          <div className={customStyles.contents}>
            {event.dates[0].display.combined}
          </div>
          {showPrice ? (
            <div className={customStyles.contents}>{event.ticketsPriceStr}</div>
          ) : null}
          <div className={customStyles.contents}>{eventInfo}</div>
          <div className={styles.buttonContainer}>
            <Link href={eventLink}>
              <Button tourTheme={theme} type="primary" ariaLabel="Get Tickets">
                {theme.ticketButtonText}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default EventImageListView;



// WEBPACK FOOTER //
// ./routes/tours/EventImageListView.js